import React from "react";
export default ({ children }) => (
  <main className="container full-screen">{children}</main>
);
